// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2bm2d","info":"UpdateTermsInfo_info__qvHXF"};